import * as supports from '@owl-nest/feature-detection'

const CACHE = new Map<string, string>()

export function getGroupSeparator(locale: string): string {
  if (CACHE.has(locale)) {
    return CACHE.get(locale)!
  }

  if (supports.numberFormat() && supports.numberFormatToParts()) {
    const numberWithGroupSeparator = 1000
    const parts = new Intl.NumberFormat(locale).formatToParts(numberWithGroupSeparator)
    const groupSeparatorPart = parts.find((part) => part.type === 'group')

    const result = groupSeparatorPart ? groupSeparatorPart.value : ''
    CACHE.set(locale, result)
    return result
  }

  console.log('Unsupported NumberFormatToParts')
  CACHE.set(locale, '')
  return ''
}

export function format(
  amount: number,
  locale: string,
  options?: {
    decimal?: string
    thousand?: string
    precision?: number
  },
) {
  if (supports.intlNumberFormat() && supports.numberFormat()) {
    const precision = options?.precision !== undefined ? options.precision : Number.isInteger(amount) ? 0 : 2

    const formatter = new Intl.NumberFormat(locale, {
      minimumFractionDigits: precision,
      maximumFractionDigits: precision,
      useGrouping: true,
      ...options,
    })

    return formatter.format(amount)
  }

  console.log('Unsupported NumberFormat')
  return amount
}

export function formatCompact(value: number, locale: string) {
  if (supports.intlNumberFormat() && supports.numberFormat()) {
    return new Intl.NumberFormat(locale, {
      notation: 'compact',
      maximumFractionDigits: 1,
    }).format(value)
  }
  console.log('Unsupported NumberFormat')
  return value
}
